@if (brandingState.ready()) {
  @if (accountLink(); as account) {
    <div class="account-link-layout" [class.account-link-layout--page]="presentation === 'page'">
      <header class="account-link-heading">
        @if(presentation !== 'popup'){<h2 id="account-link-title">{{ '¿Eres tú?' | slT }}</h2>}
        <p>{{ 'Añade {p0} a tu cuenta de ScreenLeads.' | slT:{p0:(account.provider)} }}</p>
      </header>
      <sl-card variant="outlined">
        <section class="account-identity" [attr.aria-label]="'Cuenta de ScreenLeads' | slT" aria-live="polite">
          <sl-avatar [name]="verifiedAccount() ? accountName() : ''" [src]="verifiedAvatar()" size="lg" />
          <div class="account-identity-details">
            <strong>{{ accountName() }}</strong>
            <span>{{ (((verifiedAccount()?.email))) || (((account.email))) }}</span>
            @if (verifiedAccount()?.createdAt; as createdAt) {
              <small>{{ 'Cuenta creada el {p0}' | slT:{p0:(createdAt | slDate:'dd/MM/yyyy')} }}</small>

            }
          </div>
        </section>
      </sl-card>
      @if(error()){<sl-alert variant="error" role="alert">{{ (error() | slT) }}</sl-alert>}
      @if (!accountLinkConfirmed()) {
        <p>{{ 'Te enviaremos un código a este correo para añadir {p0}.' | slT:{p0:(account.provider)} }}</p>
        <button sl-button variant="primary" type="button" [disabled]="ssoLoading() !== null" (click)="confirmAccountLink()">{{ ssoLoading() ? ('Enviando código…' | slT) : ('Sí, soy yo' | slT) }}</button>
      } @else {
        <p role="status">{{ 'Introduce el código que hemos enviado a {p0}. Caduca en 5 minutos.' | slT:{p0:(account.email)} }}</p>
        <form class="account-provider-actions" (ngSubmit)="verifyAccountLink()">
          <sl-text-field [label]="'Código de verificación' | slT"><input slNativeControl name="verificationCode" inputmode="numeric" autocomplete="one-time-code" pattern="[0-9]{6}" maxlength="6" required [(ngModel)]="verificationCode" /></sl-text-field>
          <button sl-button variant="primary" type="submit" [disabled]="ssoLoading() !== null || verificationCode.length !== 6">{{ ssoLoading()==='verify-code' ? ('Verificando…' | slT) : ('Verificar y entrar' | slT) }}</button>
        </form>
        <button sl-button variant="text" type="button" [disabled]="ssoLoading() !== null || resendSeconds()>0" (click)="confirmAccountLink()">{{ resendSeconds()>0 ? 'Reenviar código en '+resendSeconds()+' s' : ('Reenviar código' | slT) }}</button>
      }
      <button sl-button variant="secondary" type="button" [disabled]="ssoLoading() !== null" (click)="cancelAccountLink()">{{ 'No, usar otro método' | slT }}</button>
    </div>
  } @else {
  <sl-auth-login
    [layout]="presentation === 'popup' ? 'embedded' : 'page'"
    [config]="loginConfig()"
    [loading]="loading() || ssoLoading() !== null"
    [error]="error()"
    (submitRequested)="onSubmitRequested($event)"
    (modeChanged)="onModeChanged($event)"
    (socialRequested)="onSocialRequested($event)"
  ></sl-auth-login>
  }
}
